import React from "react";
import {
  Button,
  Grid,
  MenuItem,
  Modal as MuiModal,
  TextField,
  Typography,
} from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers/icons";

interface Props {
  selectedCloneUserId: any;
  handleUserSelection: any;
  cloneableUsers: any;
  showSelectCloneModal: any;
  closeShowSelectCloneModal: any;
  showCloneConfirmationModal: boolean;
  openShowCloneConfirmationModal: any;
  closeShowCloneConfirmationModal: any;
  selectedUserName: any;
  clonePrivileges: any;
}

const ClonePrivileges: React.FC<Props> = ({
  selectedCloneUserId,
  handleUserSelection,
  cloneableUsers,
  showSelectCloneModal,
  closeShowSelectCloneModal,
  showCloneConfirmationModal,
  openShowCloneConfirmationModal,
  closeShowCloneConfirmationModal,
  selectedUserName,
  clonePrivileges,
}) => {
  return (
    <MuiModal
      open={showSelectCloneModal}
      className="modal-primary"
      onClose={closeShowSelectCloneModal}
    >
      <div className="paper" style={{ width: 430 }}>
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <div className="main-header" style={{ marginBottom: "20px" }}>
                <span>Search for User to Clone?</span>
                <span id="dismiss-button" onClick={closeShowSelectCloneModal}>
                  <ClearIcon sx={{ width: 30, height: 30 }} />
                </span>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                paddingLeft: "24px",
                paddingRight: "24px",
              }}
            >
              <TextField
                size="small"
                id="GroupActions"
                value={selectedCloneUserId}
                className="autocomplete"
                variant="outlined"
                onChange={(event) => {
                  handleUserSelection(event.target.value);
                }}
                select
                sx={{
                  width: "100%",
                }}
              >
                {cloneableUsers?.map((user) => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.name_reversed}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="modal-footer"
          >
            <Grid item xs={12} className="confirm-btn-container">
              <div onClick={closeShowSelectCloneModal} className="cancel-link">
                Cancel
              </div>
              <Button
                onClick={openShowCloneConfirmationModal}
                className="confirm-btn"
                style={{ width: 156 }}
              >
                Select
              </Button>
            </Grid>
          </Grid>
        </div>

        {showCloneConfirmationModal && (
          <MuiModal open={showCloneConfirmationModal} className="modal-primary">
            <div className="paper" style={{ width: 430 }}>
              <div className="paperInner">
                <Grid container>
                  <Grid item xs={12}>
                    <div
                      className="main-header"
                      style={{ marginBottom: "20px" }}
                    >
                      <span>Clone {selectedUserName}?</span>
                      <span
                        id="dismiss-button"
                        onClick={closeShowCloneConfirmationModal}
                      >
                        <ClearIcon sx={{ width: 30, height: 30 }} />
                      </span>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      paddingLeft: "24px",
                      paddingRight: "24px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "22px",
                        color: "#1E1E1E",
                      }}
                    >
                      You are attempting to clone this user’s privileges to the
                      current user. Are you sure you want to continue?
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  className="modal-footer"
                >
                  <Grid item xs={12} className="confirm-btn-container">
                    <div
                      onClick={closeShowCloneConfirmationModal}
                      className="cancel-link"
                    >
                      Cancel
                    </div>
                    <Button
                      onClick={clonePrivileges}
                      className="confirm-btn"
                      style={{ width: 156 }}
                    >
                      Confirm
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </div>
          </MuiModal>
        )}
      </div>
    </MuiModal>
  );
};

export default ClonePrivileges;
